import Service from '@ember/service';
import { service } from '@ember/service';

export default class HeroApiService extends Service {
  @service('hero-api-auth')
  auth;

  @service('hero-api-bookings')
  bookings;

  @service('hero-api-comments')
  comments;

  @service('hero-api-goals')
  goals;

  @service('hero-api-people')
  people;
}
